
import React from 'react';
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Badge } from "@/components/ui/badge";

const Features = () => {
  const features = [
    {
      title: "Expense Tracking",
      description: "Comprehensive tracking of all caregiving-related expenses",
      benefits: ["Automatic categorization", "Receipt storage", "Monthly summaries", "Tax-ready reports"]
    },
    {
      title: "Tax Optimization",
      description: "Maximize your tax deductions and benefits",
      benefits: ["Deduction identification", "Documentation assistance", "Tax form preparation", "Expert guidance"]
    },
    {
      title: "Financial Planning",
      description: "Plan for current and future care costs",
      benefits: ["Budget forecasting", "Cost projections", "Savings goals", "Emergency planning"]
    },
    {
      title: "Benefits Discovery",
      description: "Find programs and benefits you're eligible for",
      benefits: ["Government programs", "Insurance benefits", "Community resources", "Caregiver support"]
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <section className="section-padding">
          <div className="container mx-auto px-4 md:px-6">
            <div className="text-center max-w-3xl mx-auto mb-16">
              <Badge className="mb-4 bg-careblue-100 text-careblue-600 hover:bg-careblue-200">Features</Badge>
              <h1 className="text-4xl md:text-5xl font-bold mb-6 text-careblue-800">Powerful Tools for Caregivers</h1>
              <p className="text-xl text-muted-foreground">
                Everything you need to manage your caregiving finances in one comprehensive platform.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
              {features.map((feature, index) => (
                <div key={index} className="bg-white rounded-xl p-8 shadow-soft border border-careblue-100">
                  <h2 className="text-2xl font-bold mb-4 text-careblue-800">{feature.title}</h2>
                  <p className="text-muted-foreground mb-6">{feature.description}</p>
                  <ul className="space-y-2">
                    {feature.benefits.map((benefit, benefitIndex) => (
                      <li key={benefitIndex} className="flex items-center">
                        <div className="w-2 h-2 bg-careblue-500 rounded-full mr-3"></div>
                        <span className="text-foreground">{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            
            <div className="text-center mt-16">
              <div className="bg-careblue-50 rounded-xl p-8 max-w-2xl mx-auto">
                <h2 className="text-2xl font-bold mb-4 text-careblue-800">Coming in 2025</h2>
                <p className="text-muted-foreground mb-6">
                  We're putting the finishing touches on these features. Join our waitlist to be the first to know when they're ready.
                </p>
                <button className="bg-careblue-500 hover:bg-careblue-600 text-white py-3 px-6 rounded-lg font-medium transition-colors">
                  Join Waitlist
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Features;
